import { Component, Input, ViewChild, ViewContainerRef } from "@angular/core";
import { DataResponse, UserRelationship, UserRelationshipType } from "@apiserver-rest/ponder-data-client-base";
import { getProfileImageRoute } from "../profile/profile-image-router";
import { SvgIcon, SvgIconMap } from "@ponder-shared/utils/svgIcons";
import { BusySpinComponent } from "@ponder-shared/components/busy-spin.component";
import { PonderDataClient } from "@apiserver-rest/ponder-data-client";
import { take } from "rxjs";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { ConfirmationModalComponent } from "@ponder-shared/modals/confirmation-modal.component";

@Component({
    selector: "user-friend",
    imports: [BusySpinComponent],
    templateUrl: "./user-friend.component.html"
})
export class UserFriendComponent {
    @ViewChild("confirmationModalTemplate", { read: ViewContainerRef }) private confirmationModalVcr!: ViewContainerRef;

    @Input({ required: true }) public isOwnFriends!: boolean;
    @Input({ required: true }) public relationship!: UserRelationship;

    public avatarUrl!: string;
    public username!: string;
    public displayName!: string;
    public pending!: boolean;
    public waiting!: boolean;
    public profileUrl!: string;
    public isProcessing: boolean = false;

    public readonly acceptIconSvg: string = SvgIconMap.get(SvgIcon.Check)!;
    public readonly deleteIconSvg: string = SvgIconMap.get(SvgIcon.Delete)!;

    constructor(private ponderDataClient: PonderDataClient, private events: EventBroker) {

    }

    public ngOnInit(): void {
        this.username = this.relationship.otherUsername!;
        this.displayName = this.relationship.otherDisplayName ?? this.username;
        this.avatarUrl = getProfileImageRoute(this.username);
        this.pending = this.relationship.type == UserRelationshipType.Pending;
        this.waiting = this.pending && (this.relationship.initiatorId != this.relationship.userId);
        this.profileUrl = `/user/${this.username}`;
    }

    public onAcceptClick(): void {
        if (this.isProcessing) {
            return;
        }

        this.isProcessing = true;

        this.ponderDataClient
            .userFriendAccept(this.relationship.otherUserId)
            .pipe(take(1))
            .subscribe({
                next: (response: DataResponse) => {
                    if (response.success) {
                        this.waiting = false;
                        this.pending = false;

                        this.events.profile.friendInviteAcceptedEvent.emit(this.relationship);
                    }
                }
            })
            .add(() => { this.isProcessing = false; });
    }

    public onDeleteClick(): void {
        if (this.isProcessing) {
            return;
        }

        this.isProcessing = true;

        if (this.relationship.type == UserRelationshipType.Friends) {
            // Get confirmation before deleting a friend.
            var confirmationModalRef = this.confirmationModalVcr.createComponent(ConfirmationModalComponent);

            confirmationModalRef.instance.title = "Delete Friend";
            confirmationModalRef.instance.body = `Delete friend ${this.displayName}?`;
            confirmationModalRef.instance.centered = true;
            confirmationModalRef.instance.onAcceptCallback = () => { this.completeFriendDelete(); }
            confirmationModalRef.instance.onCancelCallback = () => { this.isProcessing = false; }
        } else {
            this.completeFriendDelete();
        }
    }

    private completeFriendDelete(): void {
        console.debug("delete?");
        this.ponderDataClient
            .userFriendDelete(this.relationship.otherUserId)
            .pipe(take(1))
            .subscribe({
                next: (response: DataResponse) => {
                    if (response.success) {
                        this.waiting = false;
                        this.pending = false

                        this.events.profile.friendDeletedEvent.emit(this.relationship);
                    }
                }
            })
            .add(() => { this.isProcessing = false; });
    }
}